import styled from 'styled-components';

export const PlatformCostsContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
`;

export const TopBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 24px;
    border-bottom: 1px solid var(--color-border, #e5e7eb);
    background: var(--color-background, white);
    flex-shrink: 0;
`;

export const TopBarLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const TopBarTitle = styled.h1`
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--color-foreground, #111827);
    line-height: 1.3;
`;

export const TopBarSubtitle = styled.p`
    margin: 0;
    font-size: 12px;
    color: var(--color-muted-foreground, #6b7280);
`;

export const Body = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    min-height: 0;
`;

export const SidebarContainer = styled.aside`
    height: 100%;
    min-height: 0;
    min-width: 0;
    border-right: 1px solid var(--color-border, #e5e7eb);
    background: var(--color-background, white);
    overflow: hidden;
`;

export const Content = styled.main`
    height: 100%;
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
    background: var(--color-muted, #f8fafc);
`;
